import { streamConstants } from '../constants/streams';

const initialStreamState = {
  abTest: true,
  id: null,
  offerId: 0,
  siteId: 0,
  landings: [],
  transits: [],
  settings: {},
  postback: {
    method: 0,
    url: '',
    pixels: [],
    statuses: [],
  },
  failAction: { type: '', value: null },
  landingTracking: [],
  streamId: null,
  scripts: [],
};

const initialState = {
  streams: [],
  settings: {},
  count: 0,
  offer: {},
  selected: initialStreamState,
  filters: {},
  streamLandingSettings: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case streamConstants.RESET_STREAM:
      return {
        ...state,
        selected: initialStreamState,
      };

    case streamConstants.SET_STREAMS_SUCCESS:
      return {
        ...state,
        streams: action.streams,
        count: action.count,
        settings: { ...state.settings, ...action.settings,
          offers: { ...state.settings.offers, ...action.settings.offers }
        },
      };

    case streamConstants.ADD_STREAM_SUCCESS:
      return {
        ...state, streams: [action.stream, ...state.streams]
      };

    case streamConstants.SET_STREAM_SUCCESS:
      return {
        ...state,
        selected: action.stream,
      };

    case streamConstants.REMOVE_STREAM_SUCCESS:
      return {
        ...state,
        streams: state.streams.filter(({ id }) => id !== action.streamId),
      };

    case streamConstants.SET_STREAM_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: { ...state.settings, ...action.settings },
      };

    case streamConstants.SET_STREAM_OFFER_SUCCESS:
      return {
        ...state,
        offer: action.offer,
      };

    case streamConstants.RESET_STREAM_OFFER:
      return {
        ...state,
        offer: {},
      };

    case streamConstants.SET_STREAM_OFFER_FAILURE:
      return {
        ...state,
        offer: { id: action.payload.id, title: action.payload.title },
      };

    case streamConstants.SET_GLOBAL_POSTBACK_SUCCESS:
    case streamConstants.EDIT_GLOBAL_POSTBACK_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          globalPostback: action.globalPostback,
        },
      };
    case streamConstants.RESET_STREAMS_FILTER:
      const { name } = action;
      const filters = name ? { ...state.filters, [name]: [] } : null;

      return {
        ...state,
        filters,
      };

    case streamConstants.SET_STREAMS_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters,
        },
      };

    case streamConstants.SET_STREAM_LANDING_SETTINGS_SUCCESS:
      return {
        ...state,
        streamLandingSettings: { ...action.settings[0] }
      }
    default:
      return state;
  }
};
